import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinLira: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCoinLira"><Path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9 11.7861L6.91504 12.8291L6.24414 13.165L6.91504 14.5059L9 13.4629V17H12.4473C13.8243 17 15.1102 16.3118 15.874 15.166L16.29 14.542L15.042 13.71L14.626 14.334C14.1403 15.0624 13.3228 15.5 12.4473 15.5H10.5V12.7129L15.585 10.1709L16.2559 9.83496L15.585 8.49414L10.5 11.0361V7H9V11.7861Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoinLira;
